import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'mri-ui-badge',
  standalone: true,
  template: `
    @if (text) {
      {{ text }}
    } @else {
      <ng-content select="[mriUiBadgeText]"></ng-content>
    }
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiBadgeComponent {
  @Input() text = '';
  @Input() tooltipText: string | undefined;

  counterClass = 'mri-counter--info';

  @Input() set type(value: string) {
    switch (value) {
      case 'success':
        this.counterClass = 'mri-counter--success';
        break;
      case 'warning':
        this.counterClass = 'mri-counter--warning';
        break;
      case 'critical':
        this.counterClass = 'mri-counter--critical';
        break;
      case 'info-light':
        this.counterClass = 'mri-counter--info mri-counter--info-light';
        break;
      case 'neutral':
        this.counterClass = 'mri-counter--neutral';
        break;
      case 'info':
      default:
        this.counterClass = 'mri-counter--info';
        break;
    }
  }

  @HostBinding('class') get hostClass() {
    return `mri-counter ${this.counterClass}`;
  }
  @HostBinding('title') get title() {
    return this.tooltipText ?? '';
  }
}
